import AuthService from '@/services/AuthService'

export const namespaced = true

export const state = {
  loggedIn: false,
  userData: {}
}

export const mutations = {
  SET_USER_DATA(state, userData) {
    state.loggedIn = true
    state.userData = userData
    localStorage.setItem('user', JSON.stringify(userData))
  },
  LOGOUT(state) {
    state.loggedIn = false
    state.userData = {}
    localStorage.removeItem('user')
    //location.reload() // trebalo bi da cisti cookie

    // To delete a cookie, you just need to set the value of the cookie to empty and set the value of expires to a passed date.
    document.cookie = 'api_token= ; expires = Thu, 01 Jan 1970 00:00:00 GMT'
  }
}

export const actions = {
  login({ commit }, credentials) {
    // service
    return AuthService.login(credentials).then(response => {
      commit('SET_USER_DATA', response.data)
    })
    // .catch(error => {
    //   console.log(error)
    // })
  },
  logout({ commit }) {
    commit('LOGOUT')
  },
  changePassword() {
    //commit('LOGOUT')
  }
}

export const getters = {
  // !!!
  // ako nema {} ne mora ni return
  // ako imamo {} onda mora return
  // 1.
  //userName: state => state.credentials.user_name
  // 2.
  userName: state => {
    return state.userData.user_name
  }
}
